import { makeAutoObservable, observable, toJS  } from "mobx";
import { saveAs } from "file-saver";
import { MonthlyPerformanceService } from "../services/monthlyPerformanceService";

import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import MonthlySettingStore from "../../settings/store/monthlysettingstore";
import { gridColums } from "../../monthly-performance/ColumnHelpers";
const _ = require("underscore");
class MonthlyPerformanceStore {
  constructor() {
    makeAutoObservable(this);
  }

  productions = observable.map({});

  showNaocMonthlyProductionDialog = false;
  monthlyProductions = observable.map({});
  queryResults = [];
  wizStep = 0;
  monthlyRates = observable.map({});
  reviewData = observable.map({});
  prodHistory = [];
  selTab = "1";
  paraselTab = "1";
  showSQeryDialog = false;
  isDownloadingTemplate = false;
  isSaving = false;
  isLoading = false;
  isLoaded = false;

  sheetName = "";
  rateSheetName = "";
  showUploadErrorMessage = false;
  productionview = "gross";
  showRemarkPane = false;
  remarkObj = { title: "", remark: "<div></div>" };
  resultFromQuery = false;
  showQueryDialog = false;
  sqlCommand = "";
  sqlQueryCriteria = "";
  sqlColumns = "";
  isworking = true;
  view = "upload";
  uploadDate = moment(new Date());
  gridHeaderText = `NAOC MONTHLY PRODUCTIONS for ${moment(new Date()).format(
    "MMM-YYYY"
  )} `;
  showEmpty = true;
  uploadErrors = [];
  parauploadErrors = [];
  selRow = {};
  queryCriteria = {
    startDate: moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    endDate: moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    fromInception: false,
    specificDate: true,
  };
  disableCommand = true;
  monthlySettingsStore = MonthlySettingStore;
  isQuerying = false;
  queryColumns = [];
  showSaveDialog = false;
  saveQueryType = 1;
  savedQueryList = observable.map({});
  isfiltering = false;
  showQueryListDrawer = false;
  showQueryPreiviewDrawer = false;
  selQuery = {};
  queryGrid = {};
  qryBldrObj = {};
  gridHeader = "";
  showAdvanceQueryDialog = false;
  showPdfExportDialog = false;
  reupload = false;
  lockData = false;
  showLockDataBanner = false;
  disableDelete = true;
  statusYear = moment(new Date()).year();
  showUploadStatusDialog = false;
  isLoadingStatus = false;
  uploadStatusItems = observable.map({});

  async downlaodMonthlyProductionTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const res = await MonthlyPerformanceService.downloadTemplate();
      saveAs(res, "MonthlyProductionTemplate.xls", {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }
  async downlaodMonthlyParameterTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const res = await MonthlyPerformanceService.downloadparameterTemplate();
      saveAs(res, "suburface_parameter_template.xlsx");
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }
  async loadProductions() {
    try {
      this.isLoading = true;
      let res = [];

      res = await MonthlyPerformanceService.loadProductionHistory(
        this.queryCriteria,
        this.productionview
      );

      this.prodHistory = res.prodHistory;

      const distinctProdMonths = _.uniq(
        _.filter(_.pluck(res.prodHistory, "prodMonth"))
      ).length;

      if (res.prodHistory.length === 0) {
        this.disableCommand = true;
        this.showLockDataBanner = false;
      } else {
        if (distinctProdMonths === 1) {
          this.disableCommand = false;
          this.lockData = res.lockData;
          this.showLockDataBanner = res.lockData;
          if (!this.lockData) {
            this.disableDelete = res.lockedBy !== getCurrentUser()?.fullName;
          }
        } else {
          this.disableCommand = true;
          this.showLockDataBanner = false;
        }
      }

      this.isLoaded = true;
      this.reupload = false;
      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async saveMonthlyProduction() {
    try {
      this.isSaving = true;

      const uploadedBy = getCurrentUser()?.fullName;
      const data = [...this.reviewData.values()].map((d) => toJS(d));
      const month = Number(moment(this.uploadDate).format("M"));
      const year = Number(moment(this.uploadDate).format("YYYY"));
      const res = await MonthlyPerformanceService.saveMonthlyProduction(
        data,
        month,
        year,
        uploadedBy,
        this.reupload
      );
      console.log(res);
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  get totalOil() {
    const vals = _.map([...this.reviewData.values()], (x) => toJS(x));
    let sum = vals.reduce(
      (s, f) => Number(s) + Number(_.isNull(f.oil) ? 0 : Number(f.oil)),
      0
    );

    return sum;
  }

  resetWorkflow() {
    this.monthlyProductions.clear();
    this.monthlyRates.clear();
    this.reviewData.clear();
    this.showNaocMonthlyProductionDialog = true;
    this.wizStep = 0;
    this.sheetName = "";
    this.rateSheetName = "";
    this.reupload = false;
  }

  async query() {
    try {
      this.isQuerying = true;
      let retVal = [];
      retVal = await MonthlyPerformanceService.query(this.sqlCommand);

      if (retVal.length) {
        this.queryResults.clear();

        let columnKeys = ["#", ..._.keys(retVal[0])];
        //  console.log(columnKeys);

        let displayColumns = _.map(gridColums, (col) => {
          return _.contains(columnKeys, col.field) ? col : undefined;
        });
        displayColumns = _.filter(displayColumns) ?? [];
        this.showEmpty = false;
        this.saveQueryType = 1;
        return { displayColumns, data: retVal };
      } else {
        this.queryResults.clear();
        this.showEmpty = false;
      }

      //  console.log(retVal);
    } catch (error) {
      throw error;
    } finally {
      this.isQuerying = false;
    }
  }
  async saveQuery(query) {
    try {
      const author = getCurrentUser()?.fullName;
      query.author = author;
      query.queryType = this.saveQueryType;
      const retVal = await MonthlyPerformanceService.saveQuery(query);
      return retVal;
    } catch (error) {
      throw error;
    }
  }

  async loadSavedQuery(start, end) {
    try {
      this.isfiltering = true;
      const retVal = await MonthlyPerformanceService.loadSavedQuery(start, end);
      this.savedQueryList.clear();
      // console.log("retVal", retVal);
      retVal.forEach((sq) => {
        this.savedQueryList.set(sq.savedQueryId, sq);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isfiltering = false;
    }
  }
  async loadSavedQueryByName(fullName) {
    try {
      this.isfiltering = true;
      const retVal = await MonthlyPerformanceService.loadSavedQueryByName(
        fullName
      );
      this.savedQueryList.clear();
      // console.log("retVal", retVal);
      retVal.forEach((sq) => {
        this.savedQueryList.set(sq.savedQueryId, sq);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isfiltering = false;
    }
  }
  async clearQuery() {
    this.sqlCommand = "";
    this.sqlQueryCriteria = "";
    this.queryColumns = [];
    this.queryResults.clear();
  }
  reset() {
    this.sqlCommand = "";
    this.sqlQueryCriteria = "";
    this.queryColumns = [];
    if (this.queryGrid.current) {
      this.qryBldrObj.current.reset();
    }
  }

  async deleteQuery(query) {
    try {
      const retVal = await MonthlyPerformanceService.deleteQuery(query);
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  titleCase(string) {
    var sentence = string.split("_").join(" ").toLowerCase().split(" ");
    for (var i = 0; i < sentence.length; i++) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    //document.write(sentence.join(" "));
    return sentence.join(" ");
  }
  async runAdvanceQuery() {
    try {
      this.isQuerying = true;
      let retVal = [];
      retVal = await MonthlyPerformanceService.query(this.sqlCommand);

      if (retVal.length) {
        this.queryResults.clear();
        let indexCol = [
          {
            headerName: "#",
            valueGetter: "node.rowIndex + 1",
            width: 50,
            resizable: true,
            sortable: true,
            pivot: false,
            field: "#",
          },
        ];
        let columnKeys = [..._.keys(retVal[0])];
        console.log(columnKeys);

        let displayColumns = _.map(columnKeys, (col) => {
          return { headerName: this.titleCase(col), field: col };
        });
        displayColumns = _.filter([...indexCol, ...displayColumns]) ?? [];
        this.showEmpty = false;
        this.saveQueryType = 2;
        return { displayColumns, data: retVal };
      } else {
        this.queryResults.clear();
        this.showEmpty = false;
      }

      console.log(retVal);
    } catch (error) {
      throw error;
    } finally {
      this.isQuerying = false;
    }
  }

  async lockProduction(islocked) {
    try {
      const user = getCurrentUser()?.fullName;
      console.log("user", user);
      const retVal = await MonthlyPerformanceService.lockProduction(
        this.queryCriteria.startDate,
        islocked,
        user
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  async deleteProduction() {
    try {
      const user = getCurrentUser()?.fullName;
      console.log("user", user);
      const retVal = await MonthlyPerformanceService.deleteProduction(
        this.queryCriteria.startDate,

        user
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }

  async loadUploadStatus() {
    try {
      this.isLoadingStatus = true;
      const retVal = await MonthlyPerformanceService.loadUploadStatus();
      this.uploadStatusItems.clear();
      retVal.forEach((usi) => {
        this.uploadStatusItems.set(usi.monthlyProductionLockId, usi);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoadingStatus = false;
    }
  }
}



const monthlyPerformance = new MonthlyPerformanceStore();
export default monthlyPerformance;

